import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {ColorPath, Size} from 'types/Theme'

import {cssTheme} from '../../../themes'
import {Icon} from '../Icon'

export type StarRatingSize = Extract<Size, 'sm' | 'xs'>

interface Props {
  /** Pass through className to allow styles overrides */
  className?: string
  /** The number of stars to show */
  rating: number
  /** The size of the stars */
  size?: StarRatingSize
  /** Whether it should render inline StartRating */
  isInline?: boolean
  wrapperId?: string
  /** The color path of the stars */
  colorPath?: ColorPath
}

const IconsWrapper = styled.div`
  display: flex;
  gap: ${cssTheme.layout.spacing.s100};
  &.--is-inline {
    display: inline-flex;
  }
`

export const StarRating = ({
  rating,
  size = 'sm',
  isInline = false,
  className,
  wrapperId,
  colorPath = 'starRating.content'
}: Props) => {
  return (
    <IconsWrapper
      className={cx(isInline && '--is-inline', className)}
      id={wrapperId}
    >
      {Boolean(rating) &&
        new Array(Math.floor(rating))
          .fill('x')
          .map((_, index) => (
            <Icon
              key={`star-${index}-${size}`}
              size={size}
              name="StarSolid"
              colorPath={colorPath}
            />
          ))}
    </IconsWrapper>
  )
}
